/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  position: relative;
  display: inline-block;
  max-inline-size: 100%;
  min-inline-size: 0;
}

span {
  text-wrap: nowrap;
}

[sizing-host] {
  display: block;
  opacity: 0;
}

[internal-host] {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

slot {
  display: initial;
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
